export default __webpack_public_path__ + "static/media/memoria.5298439c.png";